import { render } from "./ArticlesAdminView.vue?vue&type=template&id=37d44c1a"
import script from "./ArticlesAdminView.vue?vue&type=script&lang=js"
export * from "./ArticlesAdminView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__